import { css } from "@emotion/css";
import isEmpty from "lodash/isEmpty";
import { LabelHTMLAttributes } from "react";
import { useTranslation } from "react-i18next";

import { getTextStyle } from "../../../../foundations/typography/styles";
import { _Label } from "../../../_assets/_Label";
import { _Text } from "../../../_assets/_Text";

interface Props extends LabelHTMLAttributes<HTMLLabelElement> {
  isRequired?: boolean;
  optionalText?: string;
  info?: React.ReactNode;
  testID?: string;
}

export function FormLabelRAC(props: Props) {
  const { t } = useTranslation();

  const {
    isRequired,
    optionalText,
    children,
    info,
    testID = "form-label",
    ...rest
  } = props;

  const optionalSuffix =
    optionalText === undefined ? t("optional") : optionalText;

  if (!children && !info) {
    return null;
  }

  return (
    <div className={styles.label} data-testid={testID}>
      {isEmpty(rest) ? (
        <_Label>{props.children}</_Label>
      ) : (
        <label className={css(getTextStyle("input/label"))} {...rest}>
          {props.children}
        </label>
      )}
      {!isRequired && optionalSuffix && (
        <_Text style="input/helper">{`(${optionalSuffix})`}</_Text>
      )}
      <div className={css({ marginLeft: "auto" })}>{info}</div>
    </div>
  );
}

const styles = {
  label: css({
    display: "flex",
    alignItems: "center",
    gap: "var(--space-1)",
    "[data-label-orientation='horizontal'] &": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  }),
};
